



































import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import Search from "@/components/UI/Search.vue";
import BtnDefault from '@/components/UI/BtnDefault.vue';


@Component({
  components: {
    Search,
    BtnDefault,
  }
})

export default class Toolbar extends Vue {

    @Prop({type: Boolean, default: {}}) protected isShowArchive!: boolean

    search:string = ''

    @Watch('search')
    searchSurvey() {
        this.$emit('searchSurvey', this.search)
    }

    addSurvey() {
        this.$emit('addSurvey')
    }

    changeArchive() {
        this.$emit('changeArchive')
    }

}
